import { Space, Typography } from 'antd';
import TableHeros from 'components/shared-components/TableHeros';

export function SpTableCard({ title = '', extra = null, tableOption = null }) {
  if (!title && !extra) {
    return <TableHeros {...tableOption} />;
  }

  return (
    <Space
      direction="vertical"
      style={{ backgroundColor: '#161E2B', borderTopLeftRadius: 10, borderTopRightRadius: 10 }}
      size={0}
    >
      <Space
        style={{
          justifyContent: 'space-between',
          border: '1px solid #000',
          borderBottom: 0,
          padding: 10,
          borderTopLeftRadius: 10,
          borderTopRightRadius: 10,
        }}
      >
        <Typography.Text>{title || ''}</Typography.Text>
        {extra}
      </Space>
      <TableHeros {...tableOption} />
    </Space>
  );
}
